<template>
  <article class="configuration">
    <confirm title="您修改了“配置信息”，是否需要保存？" cancelText="取消" confirmText="保存" v-model="show" @on-cancel="onCancel" @on-confirm="onConfirm">
    </confirm>
    <group class="config-checker-list" v-for="group in curConfigInfo" :key="group.group_name" :title="group.name">
      <x-input v-for="item in group.params" :key="item.external_name" :title="item.name" v-model="item.value" placeholder="请输入"></x-input>
    </group>
    <footer-btn title="保存配置信息" @submit="toSave('procedure')"></footer-btn>
  </article>
</template>

<script>
// 车辆信息(配置信息)
import {
  Group,
  Confirm,
  XInput
} from '@lx-frontend/cvux'
import FooterBtn from '../../components/FooterBtn'
import { config } from './restConfig'
export default {
  components: {
    FooterBtn,
    Group,
    Confirm,
    XInput
  },
  props: {
    id: [String, Number],
    source: String,
    // carModelId: [String, Number],
    configInfo: Array,
    // searchVinTimes: Number, // 识别vin的次数,没识别一次 重新渲染
    configInfoFromJzg: Array,
    procedureInfo: Object,
    configIsReady: Boolean,
    procedureIsReady: Boolean
  },
  data() {
    return {
      originConfigInfo: [], // 服务器保存的数据
      show: false, // 是否显示弹窗
      nextPage: '', // 下个页面
      curConfigInfo: []
    }
  },
  created() {
    this.originConfigInfo = JSON.parse(JSON.stringify(this.configInfo))
    if (this.configInfoFromJzg && this.configInfoFromJzg.length > 0) {
      this.curConfigInfo = JSON.parse(JSON.stringify(this.configInfoFromJzg))
    } else {
      this.curConfigInfo = JSON.parse(JSON.stringify(this.configInfo))
    }
  },
  methods: {
    goToAnother (nextPage) {
      let originConfigInfo = this.originConfigInfo
      this.nextPage = nextPage
      if (originConfigInfo) {
        // confinInfo 是否有数据变化
        this.show = originConfigInfo.some((group, indexGroup) => {
          return group.params.some((param, indexParam) => {
            return this.curConfigInfo[indexGroup].params[indexParam].value !== param.value
          })
        })
        if (!this.show) {
          this.$emit('on-after-save', nextPage)
        }
      } else {
        this.toSave(nextPage)
        // this.$emit('on-after-save', nextPage)
      }
    },
    toSave(nextPage) {
      let url = config.saveConfig[this.source](this.id)
      let configIsReady = true
      this.$rest.carInfo.create({
        info: JSON.stringify({
          config: this.curConfigInfo,
          config_is_ready: configIsReady,
          procedure: this.procedureInfo,
          procedure_is_ready: this.procedureIsReady
        })
      }, url).then(res => {
        if (res.code === 0) {
          this.showToast('保存成功')
          // 同步变更的数据到configInfo中
          let hasConfigInfoFromJzg = this.configInfoFromJzg && this.configInfoFromJzg.length > 0
          this.curConfigInfo.forEach((group, indexGroup) => {
            group.params.forEach((param, indexParam) => {
              this.configInfo[indexGroup].params[indexParam].value = param.value
              if (hasConfigInfoFromJzg) {
                this.configInfoFromJzg[indexGroup].params[indexParam].value = param.value
              }
            })
          })
          // 同步configIsReady
          this.$emit('update:configIsReady', configIsReady)
          // 同步vuex中的配置信息
          this.$emit('on-after-save', nextPage)
        } else {
          this.nextPage = ''
          this.showToast(res.message)
        }
      })
    },
    onConfirm() {
      this.show = false
      this.toSave(this.nextPage)
    },
    onCancel() {
      this.$emit('on-after-save', this.nextPage)
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less">
  @import "../../../stylesheets/modules/manage/input.less";
</style>
